import { ActionType } from '../constants/ActionTypes'
import LobbyHelper from '../services/helpers/LobbyHelper'
export default function lobbiesReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.SET_LIKE_FAV_GAMES_STATUS:
            const { likedGames, favoriteGames } = action.payload;
            const allGames = [...likedGames, ...favoriteGames];
            const stored = allGames.reduce((acc, id) => {
                acc[id] = [likedGames.includes(id) ? 1 : 0, favoriteGames.includes(id) ? 1 : 0];
                return acc;
            }, {});
            if (allGames.length) {
                LobbyHelper.storeGamesStatusLocally(stored);
            }
            return {
                ...state,
                likeFavGames: action.payload
            }
        case ActionType.GET_LOBBY_PRODUCTS_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    [`is${action.payload.widget}Loading`]: true
                }

            }
        case ActionType.GET_LOBBY_CATEGORIES_BEGIN:
        case ActionType.GET_LOBBY_BEGIN:
        case ActionType.GET_FILTERS_BEGIN:
        case ActionType.GET_LAST_PLAYED_PRODUCTS_BEGIN:
        case ActionType.GET_TRENDING_PRODUCTS_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isLoading: true
                }
            }
        case ActionType.GET_LOBBY_GROUPS_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isLoading: true,
                    products: []
                }
            }
        case ActionType.GET_LOBBY_CATEGORIES_ERROR:
        case ActionType.GET_LOBBY_GROUPS_ERROR:
        case ActionType.GET_LOBBY_ERROR:
        case ActionType.GET_FILTERS_ERROR:
        case ActionType.LIKE_PRODUCT_ERROR:
        case ActionType.DISLIKE_PRODUCT_ERROR:
        case ActionType.REMOVE_FAVORITE_PRODUCT_ERROR:
        case ActionType.ADD_FAVORITE_PRODUCT_ERROR:
        case ActionType.GET_LAST_PLAYED_PRODUCTS_ERROR:
        case ActionType.GET_TRENDING_PRODUCTS_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    error: action.payload,
                    isLoading: false
                }
            }
        case ActionType.GET_LOBBY_CATEGORIES_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    categories: action.payload.data,
                    isLoading: false,
                    isLoggedIn: action.payload.isLoggedIn
                }
            }
        case ActionType.GET_LOBBY_GROUPS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    groups: action.payload.data,
                    isLoading: false
                }
            }
        case ActionType.GET_LOBBY_PRODUCTS_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    categoryCounts: [],
                    [action.payload.widget]: [],
                    error: action.payload,
                    [`is${action.payload.widget}Loading`]: false
                }
            }
        case ActionType.GET_LOBBY_PRODUCTS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    [action.payload.widget]: action.payload.products,
                    categoryCounts: action.payload.categoryCounts,
                    [`is${action.payload.widget}Loading`]: false
                }
            }
        case ActionType.GET_LOBBY_PRODUCT_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isProductLoading: false
                }
            }
        case ActionType.GET_LOBBY_PRODUCT_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    product: action.payload.data,
                    isProductLoading: false
                }
            }
        case ActionType.GET_LOBBY_PRODUCT_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isProductLoading: true
                }
            }
        case ActionType.GET_LOBBY_PRODUCTS_AND_KEEP_OLD_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isMoreLoading: true
                }
            }
        case ActionType.GET_LOBBY_PRODUCTS_AND_KEEP_OLD_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isMoreLoading: false,
                    error: action.payload
                }
            }
        case ActionType.GET_LOBBY_PRODUCTS_AND_KEEP_OLD_SUCCESS:
            const gameList = [...state[action.payload.page][action.payload.widget], ...action.payload.products];
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    [action.payload.widget]: gameList,
                    isMoreLoading: false
                }
            }
        case ActionType.GET_LOBBY_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    lobby: action.payload.data,
                    isLoading: false
                }
            }
        case ActionType.GET_FILTERS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    filters: action.payload.data,
                    isLoading: false
                }
            }
        case ActionType.GET_MOST_LIKED_PRODUCTS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    mostLiked: action.payload.data
                }
            }
        case ActionType.SELECT_CASINO_GAME:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    selectedGame: action.payload.data
                }
            }
        case ActionType.LIKE_PRODUCT_BEGIN:
            LobbyHelper.storeSingleGameStatusLocally(action.payload, 'like')
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    ...(typeof action.payload.widget === 'object' ? { [action.payload.widget.widget]: { ...state[action.payload.page][action.payload.widget.widget], [action.payload.widget.sub]: state[action.payload.page][action.payload.widget.widget][action.payload.widget.sub].map(game => game.id === action.payload.id ? { ...game, likesCount: game.likesCount + 1, isLiked: true } : game) } } :
                        { [action.payload.widget]: state[action.payload.page][action.payload.widget].map(game => game.id === action.payload.id ? { ...game, likesCount: game.likesCount, isLiked: true } : game) })
                }
            }
        case ActionType.DISLIKE_PRODUCT_BEGIN:
            LobbyHelper.storeSingleGameStatusLocally(action.payload, 'unlike')
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    ...(typeof action.payload.widget === 'object' ? { [action.payload.widget.widget]: { ...state[action.payload.page][action.payload.widget.widget], [action.payload.widget.sub]: state[action.payload.page][action.payload.widget.widget][action.payload.widget.sub].map(game => game.id === action.payload.id ? { ...game, likesCount: game.likesCount - 1, isLiked: false } : game) } } :
                        { [action.payload.widget]: state[action.payload.page][action.payload.widget].map(game => game.id === action.payload.id ? { ...game, likesCount: game.likesCount, isLiked: false } : game) }
                    )
                }
            }
        case ActionType.ADD_FAVORITE_PRODUCT_BEGIN:
            LobbyHelper.storeSingleGameStatusLocally(action.payload, 'favorite')
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    ...(typeof action.payload.widget === 'object' ? { [action.payload.widget.widget]: { ...state[action.payload.page][action.payload.widget.widget], [action.payload.widget.sub]: state[action.payload.page][action.payload.widget.widget][action.payload.widget.sub].map(game => game.id === action.payload.id ? { ...game, isFavorite: true } : game) } } :
                        { [action.payload.widget]: state[action.payload.page][action.payload.widget].map(game => game.id === action.payload.id ? { ...game, isFavorite: true } : game) }
                    )
                }
            }
        case ActionType.REMOVE_FAVORITE_PRODUCT_BEGIN:
            LobbyHelper.storeSingleGameStatusLocally(action.payload, 'unfavorite')
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    ...(typeof action.payload.widget === 'object' ? { [action.payload.widget.widget]: { ...state[action.payload.page][action.payload.widget.widget], [action.payload.widget.sub]: state[action.payload.page][action.payload.widget.widget][action.payload.widget.sub].map(game => game.id === action.payload.id ? { ...game, isFavorite: false } : game) } } :
                        { [action.payload.widget]: state[action.payload.page][action.payload.widget].map(game => game.id === action.payload.id ? { ...game, isFavorite: false } : game) }
                    )
                }
            }
        case ActionType.GET_LAST_PLAYED_PRODUCTS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    lastPlayed: action.payload.data
                }
            }
        case ActionType.GET_TRENDING_PRODUCTS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    trendingProducts: action.payload.data
                }
            }
        case ActionType.GET_LEFTBAR_PRODUCTS_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isLeftBarProductsLoading: true
                }
            }
        case ActionType.GET_LEFTBAR_PRODUCTS_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    error: action.payload,
                    isLeftBarProductsLoading: false
                }
            }
        case ActionType.GET_LEFTBAR_PRODUCTS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    leftBarProducts: action.payload.data,
                    isLeftBarProductsLoading: false
                }
            }
         
        case ActionType.GET_SEO_PAGE_PRODUCTS_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isSeoPageProductsLoading: true
                }
            }
        case ActionType.GET_SEO_PAGE_PRODUCTS_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    error: action.payload,
                    isSeoPageProductsLoading: false
                }
            }
        case ActionType.GET_SEO_PAGE_PRODUCTS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    seoPageProducts: action.payload.data,
                    isSeoPageProductsLoading: false
                }
            }
        case ActionType.RESET_MULTIVIEW_LOADING_STATE:
            return {
                ...state,
                'single-game': {
                    isGameViewProductsLoading: false,
                    isLeftBarProductsLoading: false
                }
            }
        case ActionType.GET_GAME_VIEW_PRODUCTS_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    isGameViewProductsLoading: true
                }
            }
        case ActionType.GET_GAME_VIEW_PRODUCTS_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    error: action.payload,
                    isGameViewProductsLoading: false
                }
            }
        case ActionType.GET_GAME_VIEW_PRODUCTS_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    gemeViewProducts: action.payload.data,
                    isGameViewProductsLoading: false
                }
            }
        case ActionType.ADD_MULTIVIEW_GAME:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    addGame: action.payload.data
                }
            }
        case ActionType.GET_MY_CASINO_GAMES_BEGIN:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    myCasinoGamesLoading: true
                }
            }
        case ActionType.GET_MY_CASINO_GAMES_ERROR:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    error: action.payload,
                    myCasinoGamesLoading: false
                }
            }
        case ActionType.GET_MY_CASINO_GAMES_SUCCESS:
            return {
                ...state,
                [action.payload.page]: {
                    ...state[action.payload.page],
                    myCasinoGames: action.payload.data,
                    myCasinoGamesLoading: false
                }
            }
        case ActionType.GET_LOBBY_HOME_NAV_BAR_SUCCESS:
            return {
                ...state,
                lobbyNavBar: action.payload.data,
            }
        
        case ActionType.GET_SEARCH_POPUP_GROUPS_BEGIN:
            return {
                ...state,
                isGroupLoading: true
            }
        case ActionType.GET_SEARCH_POPUP_GROUPS_SUCCESS:
            return {
                ...state,
                searchPopupGroupList: action.payload,
                isGroupLoading: false
            }
        case ActionType.GET_SEARCH_POPUP_GROUPS_ERROR:
            return {
                ...state,
                    isGroupLoading: false
            }    
        default:
            return state;
    }
}

